var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1059_2306)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5967,
    y: 15.8952,
    width: 48.8629,
    height: 41.7984,
    fill: "#113C4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 0C16.3733 0 0 16.3733 0 36.5C0 56.6267 16.3733 73 36.5 73C56.6267 73 73 56.6267 73 36.5C73 16.3733 56.6267 0 36.5 0ZM47.7755 43.4745C48.9648 44.6638 48.9648 46.5862 47.7755 47.7755C47.1823 48.3686 46.4037 48.6667 45.625 48.6667C44.8463 48.6667 44.0677 48.3686 43.4745 47.7755L36.5 40.8009L29.5255 47.7755C28.9323 48.3686 28.1537 48.6667 27.375 48.6667C26.5963 48.6667 25.8177 48.3686 25.2245 47.7755C24.0353 46.5862 24.0353 44.6638 25.2245 43.4745L32.1991 36.5L25.2245 29.5255C24.0353 28.3362 24.0353 26.4138 25.2245 25.2245C26.4138 24.0353 28.3362 24.0353 29.5255 25.2245L36.5 32.1991L43.4745 25.2245C44.6638 24.0353 46.5862 24.0353 47.7755 25.2245C48.9648 26.4138 48.9648 28.3362 47.7755 29.5255L40.8009 36.5L47.7755 43.4745Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1059_2306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRounded);
export default __webpack_public_path__ + "static/media/circle-rounded.87d34fb4256db44fb5ffcc6c3f38eaaf.svg";
export { ForwardRef as ReactComponent };